
import { getQueryString } from './utils';
import browser from './device';

function getDownloadUrl(option) {

    var downloadUrl;
    var ct = option.ct || 'wap';
    var key = option.key || 'oldtranspage';
    if (browser.isAndroid) {
        downloadUrl = "https://rel.huya.com/c?key=" + key;
    } else if (browser.isIos) {
        if(browser.isIpad) {
            downloadUrl = 'https://itunes.apple.com/app/id886103288';
        } else {
            downloadUrl = 'https://itunes.apple.com/app/apple-store/id871095743?pt=118583270&ct=' + ct + '&mt=8';
        }
    }
    return downloadUrl;
}

export default getDownloadUrl;



// WEBPACK FOOTER //
// ./src/utils/getDownloadUrl.js